import { inject, Service } from '@angular/core';

import { BaasToastMessage, BaasToastPort } from '@lvflanders/bar-ui';

import { BaasToastMessageService } from './baas-toast-message-service';

/**
 * Angular implementation of BaasToastPort that delegates to BaasToastMessageService.
 */
@Service({ autoProvided: false })
export class BaasToastPortAdapter implements BaasToastPort {
    readonly #toastMessageService = inject(BaasToastMessageService);

    show(message: BaasToastMessage): string {
        const { element, ...rest } = message;
        return this.#toastMessageService.addMessage({ ...rest, _element: element });
    }

    removeMessage(id: string): void {
        this.#toastMessageService.removeMessage(id);
    }

    removeMessages(): void {
        this.#toastMessageService.removeMessages();
    }
}
